<script lang="ts">
  import type { Snippet } from 'svelte';

  let {
    children,
    gap,
    xalign,
    yalign,
    class: className,
  }: {
    children: Snippet;
    gap?: number;
    xalign?: 'start' | 'center' | 'end';
    yalign?: 'start' | 'center' | 'end';
    class?: string;
  } = $props();
</script>

<div
  class={[
    'flex flex-col',
    gap && `gap-${gap}`,
    xalign && `items-${xalign}`,
    yalign && `justify-${yalign}`,
    className,
  ]}
>
  {@render children()}
</div>
